var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeakDownWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5117 9.85107C15.7241 9.63881 16.0675 9.63872 16.2783 9.85107C16.4906 10.0634 16.4905 10.4068 16.2783 10.6177L13.0029 13.8931C12.7348 14.161 12.3794 14.3081 12 14.3081C11.6206 14.3081 11.2652 14.161 10.9971 13.8931L7.72168 10.6177C7.50928 10.4053 7.50928 10.062 7.72168 9.85107C7.93408 9.63868 8.27738 9.63869 8.48828 9.85107L11.7637 13.1265C11.8902 13.2525 12.1099 13.2526 12.2363 13.1265L15.5117 9.85107Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeakDownWhite);
export default __webpack_public_path__ + "static/media/beak_down_white.6ff9c4791317f05c2afbfa7a87f6ed4f.svg";
export { ForwardRef as ReactComponent };